export const SPACER_SIZE = ["xxxs", "xxs", "xs", "s", "m", "l", "xl", "xxl"] as const;
